import homePage from './homePage';
import homeSlide from './homeSlide';

export default {
    homePage,
    homeSlide,
};
